import { gql } from 'apollo-angular';

export const GeneratePDFDocument = gql`
  query generatePDF($instanceId: Int!) {
    generatePDF(instanceId: $instanceId)
  }
`;
